module.exports = __webpack_public_path__ + "static/media/schedule.062f8e1c.svg";